// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#servers-container .img-responsive {\n  max-width: 100%;\n  height: auto;\n}\n", "",{"version":3,"sources":["webpack://./src/components/Body/style.less"],"names":[],"mappings":"AAAA;EAEQ,eAAA;EACA,YAAA;AAAR","sourcesContent":["#servers-container {\n    .img-responsive{\n        max-width: 100%;\n        height: auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
